import { render, staticRenderFns } from "./direct-credit-transfer-form.vue?vue&type=template&id=116045af&"
import script from "./direct-credit-transfer-form.vue?vue&type=script&lang=js&"
export * from "./direct-credit-transfer-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports